import { aiDigitalData } from "@/mocks/aiDigitalData";

export default function HeroSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-[62svh] md:min-h-[58svh] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={aiDigitalData.hero.image}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/65 via-foreground-950/45 to-foreground-950/75" />
        <div className="absolute top-[-8%] right-[-5%] w-[45vw] h-[45vw] rounded-full bg-primary-500/8 blur-[90px] pointer-events-none" />
        <div className="absolute bottom-[-5%] left-[-8%] w-[40vw] h-[40vw] rounded-full bg-accent-500/6 blur-[80px] pointer-events-none" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1200px] mx-auto px-4 md:px-8 pt-14 md:pt-20 pb-10 md:pb-16">
        {/* Breadcrumbs */}
        <nav className="mb-5 md:mb-6" aria-label="パンくず">
          <ol className="flex items-center flex-wrap gap-1 text-xs md:text-sm">
            {aiDigitalData.hero.breadcrumbs.map((crumb, idx) => (
              <li key={idx} className="flex items-center gap-1">
                {crumb.href ? (
                  <a
                    href={crumb.href}
                    className="text-background-100/60 hover:text-background-100 transition-colors"
                  >
                    {crumb.label}
                  </a>
                ) : (
                  <span
                    className={
                      idx === aiDigitalData.hero.breadcrumbs.length - 1
                        ? "text-background-100/90"
                        : "text-background-100/60"
                    }
                  >
                    {crumb.label}
                  </span>
                )}
                {idx < aiDigitalData.hero.breadcrumbs.length - 1 && (
                  <span className="text-background-100/40" aria-hidden="true">
                    ＞
                  </span>
                )}
              </li>
            ))}
          </ol>
        </nav>

        <div className="max-w-3xl">
          {/* Service label */}
          <div className="flex items-center gap-3 mb-4 md:mb-5">
            <span className="inline-block text-[10px] md:text-xs font-bold tracking-[0.12em] uppercase text-primary-300 px-2.5 py-1 rounded-full border border-primary-300/30 font-label">
              {aiDigitalData.hero.serviceLabel}
            </span>
            <span className="text-[10px] md:text-xs font-medium tracking-[0.12em] uppercase text-background-100/70 font-label">
              {aiDigitalData.hero.serviceSubLabel}
            </span>
          </div>

          <h1 className="font-heading text-[1.7rem] sm:text-3xl md:text-[2.5rem] lg:text-[2.75rem] font-bold text-background-50 leading-[1.55] tracking-tight mb-4 md:mb-5">
            {aiDigitalData.hero.mainCopy.split("\n").map((line, i) => (
              <span
                key={i}
                className={`inline md:block ${i === 0 ? "md:mb-1.5" : ""}`}
              >
                {line}
              </span>
            ))}
          </h1>

          <p className="text-sm md:text-base text-background-100/85 leading-relaxed max-w-xl mb-6 md:mb-7">
            {aiDigitalData.hero.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-7 md:mb-9">
            <button
              onClick={() => handleClick("#contact")}
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              AI・デジタル導入について相談する
              <i className="ri-arrow-right-line" />
            </button>
            <button
              onClick={() => handleClick("#implementation-support")}
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border border-background-100/50 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              支援内容を見る
              <i className="ri-arrow-down-line" />
            </button>
          </div>

          {/* Tags */}
          <div className="flex flex-wrap gap-2 md:gap-2.5">
            {aiDigitalData.hero.tags.map((tag) => (
              <span
                key={tag.label}
                className="inline-flex items-center gap-1.5 px-2.5 py-1 md:px-3 md:py-1.5 rounded-full bg-background-50/12 text-background-100 text-[11px] md:text-xs font-medium backdrop-blur-sm border border-background-50/8"
              >
                <i className={`${tag.icon} text-[11px] md:text-xs`} />
                {tag.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}